module.exports = __webpack_public_path__ + "img/skull_8.b911d712.png";